export default __webpack_public_path__ + "static/media/kabicare.465eaa91.webp";